/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceSidebarConfig } from "./SpaceSidebarConfig";
import { HeaderDetectionOptions } from "../../files/types/HeaderDetectionOptions";
export const SpaceSettings = core.serialization.object({
    sidebarConfig: SpaceSidebarConfig.optional(),
    filesMappedAfterJob: core.serialization.string().optional(),
    extractionOptions: HeaderDetectionOptions.optional(),
    omitActions: core.serialization.list(core.serialization.string()).optional(),
    omitRowSelectionToolbar: core.serialization.boolean().optional(),
});
